var _path, _rect, _rect2, _rect3, _path2, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotodashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gotodashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M3.125,20v1.125H5.7L2,24.83l.8.8,3.7-3.7V24.5H7.625V20Z",
    transform: "translate(-0.875 -8.75)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 1.125,
    height: 2.813,
    transform: "translate(13.5 11.813)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 1.125,
    height: 5.625,
    transform: "translate(11.25 9)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 1.125,
    height: 4.5,
    transform: "translate(9 10.125)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M16.625,2H3.125A1.126,1.126,0,0,0,2,3.125v6.75H3.125V8.188h13.5v8.438H9.875V17.75h6.75a1.127,1.127,0,0,0,1.125-1.125V3.125A1.126,1.126,0,0,0,16.625,2Zm-9,5.063h-4.5V3.125h4.5Zm1.125,0V3.125h7.875V7.063Z",
    transform: "translate(-0.875 -0.875)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotodashboard);
export default __webpack_public_path__ + "static/media/gotodashboard.414ad252839e33dae52c510880370c7b.svg";
export { ForwardRef as ReactComponent };